/* global axios */
import ApiClient from './ApiClient';

class SkySetupAPI extends ApiClient {
  constructor() {
    super('sky_setup', { accountScoped: true });
  }

  run() {
    return axios.post(this.url);
  }
}

export default new SkySetupAPI();
